/**** session clear when user enter from menue start  ****/
setTimeout(function(){        
    jQuery(".menu-item").click(function() {     
      localStorage.clear();
    });
}, 1600);  

